import ar_white from "../../assets/images/ar_white.svg";
import home_white from "../../assets/images/home_white.svg";
import time_pc from "../../assets/images/time_pc.webp";
import time_mobi from "../../assets/images/time_mobi.webp";

export default function TimeNewBanner() {
  return (
    <div className="w-full ">
      <div
        className="block md:hidden lg:hidden w-full relative  h-[12rem] mt-16 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${time_mobi})`,
        }}
      >
        <div className="w-full absolute top-0 h-[12rem] ">
          <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-4">
            <div className="w-full h-[2.625rem] rounded-[40px] flex justify-center items-center ">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Tin tức
                </p>
              </div>
            </div>
            <p className="text-[1.5rem] font-semibold text-white whitespace-nowrap">
              Tin tức và sự kiện
            </p>
            <p className="text-white w-[350px] text-center">
              Cập nhật những xu hướng công nghệ giáo dục mới nhất và những hoạt
              động nổi bật từ BlueSkyIT
            </p>
          </div>
        </div>
      </div>
      <div
        className="hidden md:block lg:block w-full relative h-[20rem] mt-28 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${time_pc})`,
        }}
      >
        <div className="w-full h-[20rem] ">
          <div className="mx-auto w-full flex flex-col gap-2 items-center justify-center pt-20">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Tin tức
                </p>
              </div>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Tin tức và sự kiện
            </p>
            <p className="text-white">
              Cập nhật những xu hướng công nghệ giáo dục mới nhất và những hoạt
              động nổi bật từ BlueSkyIT
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
